import { useEffect } from "react";
import { createContainer } from "unstated-next";

import { Auth } from "shared/@auth/Auth";
import { useLogger } from "shared/@hooks/useLogger";
import { useQuery } from "react-query";

import { ENVIRONMENT_CONFIG } from "shared/globals";

const iboLookupApiBase = (
  ENVIRONMENT_CONFIG.permissionsApiBase || ENVIRONMENT_CONFIG.apiBase
).replace(/\/$/, "");

export function useIBOInfo(iboNumber) {
  const { makeAuthedRequest } = Auth.useContainer();
  const { logError } = useLogger({ prefix: "useIBOInfo" });

  const { isLoading, isError, data, error, refetch } = useQuery(
    ["ibo", iboNumber],
    async () => {
      if (iboNumber == null) {
        return null;
      }

      return makeAuthedRequest(
        `${iboLookupApiBase}/membership/ibo/${iboNumber}`
      ).then(async (res) => {
        if (res.ok) {
          return res.json();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      });
    }
  );

  useEffect(() => {
    if (isError) {
      logError(error);
    }
  }, [isError, error]);

  return {
    isLoading,
    isError,
    iboInfo: data,
    error,
    refreshIBOInfo: refetch,
  };
}

export const IBOInfo = createContainer(useIBOInfo);
